<template>
    <div>
  
      <el-row style="margin-bottom:10px;">
        <el-col :span="18" class='flex'>
        </el-col>
        <el-col :span="6" >
          <el-button
            v-if='addMicrolectureTypeMain'
            @click=" $form('addMicrolectureTypeMain') "
            size='small'
            type="primary"
            style="float:right"
            icon='el-icon-circle-plus'
          >添加微课主类型
          </el-button>
        </el-col>
      </el-row>
  
      <mytable
        :tableColums='tableColums_getMicrolectureTypeMainLists'
        api='getMicrolectureTypeMainLists'
        updateapi='updateMicrolectureTypeMain'
        :height="H-165" >
      </mytable> 
  
      <myform
        :viewobj='{
          addMicrolectureTypeMain:    [ "新增微课主类型信息", "el-icon-circle-plus" ],
          updateMicrolectureTypeMain: [ "修改微课主类型信息", "el-icon-edit-outline"],
          $succeed$: getMicrolectureTypeMainLists
        }'
        @close='$form("addMicrolectureTypeMain","reset")' >
        <template v-slot:mtmLimitNum="{ Myformdata }">
        <el-select v-model='Myformdata.mtmLimitNum' clearable>
          <el-option  label="不限制" :value="0"></el-option>
          <el-option  label="展示1个" :value="1"></el-option>
        </el-select>
      </template>
        <!-- <hide slot='mtmId' /> -->
      </myform>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        mtmId: null,
  
        tableColums_getMicrolectureTypeMainLists: {
          $selection: false,
  
          mtmName: '微课主类型',
  
          mtmLimitNum: '练习场景数量限制',
  
          mtmOrder: '排序',
          // ycDelete: ['状态',,'@v-if: 1:正常 🔍#(--Themecolor),  3:弃用 🖊#warn, 2:已删除 ❌#danger+'],
  
          $operation: [
            '操作', 200,
            this.updateMicrolectureTypeMain && `@text: 编辑#success
             @click: $form("updateMicrolectureTypeMain",$row)
            `,
            this.deleteMicrolectureTypeMain && `@text: 删除#danger
             @click: _confirm('确定要删除该微课主类型吗?')
                     .trigger('deleteMicrolectureTypeMain',{mtmId:$row.mtmId})
                     .trigger('getMicrolectureTypeMainLists')
            `,
          ],
  
        },
  
      };
    },
  
    watch: {
      
    },
  
    methods: {},
  
    created() {
      this.getMicrolectureTypeMainLists();
    }
  };
  </script>
  
  <style scoped>
  </style>
  


// WEBPACK FOOTER //
// src/views/bussiness/weikeMainType.vue